import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Show the modal when content is loaded
    this.element.classList.remove("hidden")
    this.element.classList.add("flex")
  }

  close() {
    // Hide the modal
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    
    // Clear the turbo frame content
    this.element.innerHTML = ""
  }

  // Close modal when clicking outside
  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }
}